import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import './assets/scss/index.scss'
import store from './stores/user'
import * as firebase from 'firebase/app'
import 'firebase/database'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from "vue2-google-maps/dist/components/cluster"

Vue.config.productionTip = false

var firebaseConfig = {
	apiKey: "AIzaSyAG7ToUumc5o0RLc_QEh2FPZLv1Iu_HpUc",
	authDomain: "sosclick-1d067.firebaseapp.com",
	databaseURL: "https://sosclick-1d067.firebaseio.com",
	projectId: "sosclick-1d067",
	storageBucket: "sosclick-1d067.appspot.com",
	messagingSenderId: "614190041654",
	appId: "1:614190041654:web:472e522e02a23dc8986697"
};
firebase.initializeApp(firebaseConfig);

Vue.component('GmapCluster', GmapCluster);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAVx5gJCh9MATmWOFIXOONY-YCc9R3yPlg',
  },
  installComponents: true
})

new Vue({
	vuetify,
	router,
	store,
	render: h => h(App)
}).$mount('#app')
